import 'react';
import { Radio } from '@shipengine/giger';
import { getInsuranceCardStyles, getRadioStyles } from './InsuranceCardStyles.js';
import { InsuranceCardHeader } from './InsuranceCardHeader.js';
import { jsxs, jsx } from '@emotion/react/jsx-runtime';
import { UpsellInsuranceType } from '../../types/upsell.js';

const ConditionalRadio = _ref => {
  let {
    condition,
    wrapper,
    children
  } = _ref;
  return condition ? wrapper(children) : children;
};
const InsuranceCard = _ref2 => {
  let {
    children,
    currency,
    insuranceType,
    hasRadio = true,
    isChecked,
    radioName,
    onChange,
    price,
    isRecommended = false,
    title
  } = _ref2;
  const finalPrice = [UpsellInsuranceType.NO_INSURANCE, UpsellInsuranceType.STANDARD].includes(insuranceType) ? undefined : price;
  return jsxs("section", {
    css: getInsuranceCardStyles(hasRadio && !!isChecked),
    children: [jsx(ConditionalRadio, {
      condition: hasRadio,
      wrapper: children => jsx(Radio, {
        name: radioName,
        value: insuranceType,
        onChange: onChange,
        checked: isChecked,
        css: getRadioStyles,
        children: children
      }),
      children: jsx(InsuranceCardHeader, {
        title: title,
        price: finalPrice,
        currency: currency,
        isRecommended: isRecommended
      })
    }), children]
  });
};

export { InsuranceCard };
//# sourceMappingURL=InsuranceCard.js.map
